import 'intersection-observer';
import '@babel/polyfill';
import './components/picturefill';
import Choices from 'choices.js';
import objectFitImages from 'object-fit-images';
import sal from 'sal.js';
import * as helpers from './helpers';
import StratisMessage from './components/message';
import initPreloader from './components/preloader';
import Dropdown from './components/dropdown';
import Megamenu from './components/megamenu';
import ResponsiveEvent from './components/responsive-event';
import linkExternalNewWindow from './components/new_window';
import Tooltip from './components/accesstooltip';
import Agreement from '../components/agreement/agreement';
import {
    dateManagement,
    enableTimePicker,
} from './components/stratis_datepicker';
import initDateRangeController from './components/stratis_daterange';
import initGalleries from './components/galleries';
import initSelectCondition from './components/select-condition';
import toTop from '../components/go-to-top/go-to-top';
import flashInfoLocalstorage from '../components/flash-info/flash-info';
import publicationCoverflowSlider from '../components/alire/alire-coverflow';
import managePageImage from '../components/page-image/page-image';
import initStratisMenu from '../components/stratis-menu/stratis-menu';
import SlideToggler from './components/slideToggler';
import initCarousels from './components/carousel';
import initMultiselect from '../components/multiselect/multiselect';
import initLocaliserPopup from './components/localiser-popup';
import formsHandler from './components/formsHandler';
import fixedSidebar from './components/fixed-sidebar';
import './components/pass-sprot';
import likeButton from './components/like-button';
import sameCategory from '../components/same-category/same-category';
import FixedElement from './components/fixed-element';
import OpenHeaderPopup from './components/open-header-popup';
import fancyboxPopups from './components/fancybox-popups';

const event = new ResponsiveEvent();

document.addEventListener('DOMContentLoaded', () => {
    initCarousels();
    initStratisMenu();
    objectFitImages('img');
    toTop();
    sal();
    linkExternalNewWindow();
    flashInfoLocalstorage();
    dateManagement();
    initDateRangeController();
    enableTimePicker();
    managePageImage();
    helpers.objectIsPolyfill();
    initLocaliserPopup();
    sameCategory();
    initMultiselect();
    formsHandler();
    publicationCoverflowSlider();
    initSelectCondition();
    likeButton();

    const openPopup = new OpenHeaderPopup();

    const header = FixedElement.create('.header:not(.-map) .header-bar', {
        mode: 'up',
        onScroll: () => {
            // Close open dropdowns when scrolling
            Object.values(window.dropdownList).forEach((el) => {
                if (el.selector) {
                    const parent = document.querySelector('.header-bar');
                    if (parent && parent.contains(el.selector) && helpers.hasClass(el.selector, '-is-open')) {
                        el.close();
                    }
                }
            });
        },
    });

    const searchPopupHandler = () => {
        $(document).on('afterShow.fb', (e, instance, slide) => {
            const fancyboxContent = instance.current.$content[0];
            const shouldAccessibilityInit = fancyboxContent && helpers.hasClass(fancyboxContent, 'search-popup');
            const tabbableElements = helpers.getFocusableElements(fancyboxContent, false);

            const tabHandler = (keyEvent) => {
                // Focus trap

                if (keyEvent.key.toLowerCase() === 'tab'
                    && tabbableElements.length
                    && Object.is(document.activeElement, tabbableElements[tabbableElements.length - 1])) {
                    tabbableElements[0].focus();
                }

                // Closing by "Escape" button pressing

                if (keyEvent.key.toLowerCase() === 'escape' || keyEvent.key.toLowerCase() === 'esc') {
                    $.fancybox.close();
                }
            };

            $.fancybox.defaults.afterClose = () => {
                document.removeEventListener('keydown', tabHandler);
            };

            const accessibilityInnit = shouldAccessibilityInit ? (
                document.addEventListener('keydown', tabHandler)
            ) : null;
        });
    };

    searchPopupHandler();

    // Initializing click roll in the sidebar of map
    window.addEventListener('openPopup', () => {
        const clickRoll = new Dropdown('.click-roll', {
            wrapperClass: 'click-roll',
            dropdownClass: 'click-roll__block',
            btnClass: 'click-roll__toggle',
            closeOnOutsideClick: false,
            openTypeSlide: true,
            isWrapContent: true,
        });
    });

    document.createElement('picture');

    const drop = new Dropdown();

    // Create DefaultMenu with settings
    const menu = new Megamenu('.mnv-menu', {
        menu: {
            type: 'aside',
        },
        overlay: {
            show: false,
        },
        beforeOpenMenu: () => {
            openPopup.closePopup();
        },
    });

    const moreFilters = new Dropdown('.filters__dropdown', {
        wrapperClass: 'filters__dropdown',
        dropdownClass: 'filters__dropdown-block',
        btnClass: 'filters__dropdown-toggle',
        closeOnOutsideClick: false,
        openTypeSlide: true,
        focusTrap: false,
    });

    const checkboxDropdown = new Dropdown('.checkbox-dropdown', {
        wrapperClass: 'checkbox-dropdown',
        dropdownClass: 'checkbox-dropdown__block',
        btnClass: 'checkbox-dropdown__toggle',
        closeOnOutsideClick: false,
        focusTrap: false,
        onInit(instance) {
        },
        afterOpen(instance) {
        },
    });

    const sameCategoryWrapper = document.querySelector('.same-category__wrapper');

    if (sameCategoryWrapper !== null) {
        const categoryWrapper = new Dropdown(sameCategoryWrapper, {
            wrapperClass: 'same-category__wrapper',
            dropdownClass: 'same-category__list',
            outsideToggle: true,
            outsideToggleId: 'same-category__toggle',
            closeOnOutsideClick: false,
            openTypeSlide: false,

        });
    }

    // Turn on slideToggle
    const toggleItems = [...document.querySelectorAll('[data-sd-content]')];
    toggleItems.forEach((toggleItem) => {
        const toggleItemName = toggleItem.dataset.sdContent;

        const toggleTriggers = [...document.querySelectorAll(`[data-sd-trigger="${toggleItemName}"]`)];
        const item = toggleTriggers.length > 0 && new SlideToggler(toggleItem);

        if (item) {
            toggleTriggers.forEach((toggleTrigger) => {
                const action = toggleTrigger.getAttribute('data-sd-action') || 'toggle';
                toggleTrigger.addEventListener('click', () => helpers.executeIfFunction(item[action].bind(item)));
            });
        }
    });

    // Add class to ancestor
    // Find ancestor and add to it a class
    // Just add to element data attribute with selector and class: data-add-ancestor="container-wrapper,-dark"
    const addClassToAncestors = [].slice.call(document.querySelectorAll('[data-add-ancestor]'));
    addClassToAncestors.forEach((child) => {
        const [selector, cls] = child.getAttribute('data-add-ancestor')
            .split(',', 2);
        const ancestor = helpers.findAncestor(child, selector);
        if (ancestor && cls) {
            helpers.addClass([ancestor], cls);
        }
    });

    // Add this block with class <span class="ghost" data-remove-section="class"></span>
    const removeEmptySection = [].slice.call(document.querySelectorAll('[data-remove-section]'));
    removeEmptySection.forEach((child) => {
        const el = child.getAttribute('data-remove-section');
        const ancestor = helpers.findAncestor(child, el);
        if (ancestor) {
            ancestor.parentNode.removeChild(ancestor);
        }
    });

    // Disable ctrl+v (paste) event for target elements
    const disablePasteElArray = [...document.querySelectorAll('.js-disable-paste')];

    let ctrlDown = false;
    const ctrlKey = 17;
    const cmdKey = 91;
    const vKey = 86;
    const cKey = 67;

    document.addEventListener('keydown', (e) => {
        if (e.keyCode === ctrlKey || e.keyCode === cmdKey) ctrlDown = true;
    });

    document.addEventListener('keyup', (e) => {
        if (e.keyCode === ctrlKey || e.keyCode === cmdKey) ctrlDown = false;
    });

    disablePasteElArray.forEach((disablePaste) => {
        disablePaste.addEventListener('keydown', (e) => {
            if (ctrlDown && (e.keyCode === vKey || e.keyCode === cKey)) {
                e.preventDefault();
                return false;
            }
        });
    });

    // Init choices autocomplete
    const autocompleteElArray = [...document.querySelectorAll('.js-select-autocomplete')];

    autocompleteElArray.forEach((el) => {
        const _ = new Choices(el, {
            removeItemButton: false,
            itemSelectText: '',
            renderChoiceLimit: -1,
            searchResultLimit: 4,
            noResultsText: 'Aucun résultat',
            noChoicesText: 'Aucun choix',
            fuseOptions: {
                threshold: 0,
                location: 0,
                distance: 50,
            },
        });
    });

    const inputsToRemoveSpaces = ['.header-search__form-input input, #search-input'];

    inputsToRemoveSpaces.forEach((fieldSelector) => {
        const fieldsArray = [...document.querySelectorAll(fieldSelector)];
        fieldsArray.forEach((field) => {
            field.value = field.value.trim();
        });
    });

    // Scroll button in hero
    const goToDownBtn = document.querySelector('.hero-down');
    const siteMain = document.getElementById('main');

    if (goToDownBtn && siteMain) {
        goToDownBtn.addEventListener('click', (ev) => {
            ev.preventDefault();
            window.scrollTo({
                top: siteMain.offsetTop,
                behavior: 'smooth',
            });
        });
    }

    // Fix for IOS
    const updateHeightInIphone = () => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    updateHeightInIphone();

    // We listen to the resize event
    window.addEventListener('resize', () => {
        // We execute the same script as before
        updateHeightInIphone();
    });
});

window.addEventListener('load', () => {
    initPreloader();
    initGalleries();
    fancyboxPopups();
    fixedSidebar();

    $.fancybox.defaults.beforeLoad = (fancybox) => {
        if (fancybox.current.type === 'iframe' && fancybox.current.opts.$orig[0].hasAttribute('title')) {
            fancybox.current.opts.iframe.attr.title = fancybox.current.opts.$orig[0].getAttribute('title');
        }
    };

    const filterToggles = document.querySelectorAll('.filters .filters__dropdown-toggle');

    if (filterToggles) {
        [...filterToggles].forEach((toggle) => {
            toggle.addEventListener('click', () => {
                if (toggle.textContent === 'Voir tous les filtres') {
                    toggle.textContent = 'Moins de filtres';
                } else {
                    toggle.textContent = 'Voir tous les filtres';
                }
            });
        });
    }

    const figureWithCaptions = document.querySelectorAll('.js-figure');

    if (figureWithCaptions) {
        [...figureWithCaptions].forEach((item) => {
            const figcaptionToggle = item.querySelector('.js-caption-toggle');
            const figcaption = item.querySelector('.js-caption');

            figcaptionToggle.addEventListener('click', (evt) => {
                evt.preventDefault();
                figcaption.classList.toggle('-hide');
            });
        });
    }

    const siteImages = [].slice.call(document.getElementsByTagName('img')); // Edge fix

    siteImages
        .filter(img => !img.hasAttribute('data-ofi-src')) // Exclude object-fit images
        .filter(img => img.src.indexOf('.svg') === -1) // Exclude svg since they can return 0 sometimes
        .forEach((img) => {
            if (!img.naturalHeight) {
                helpers.addClass(img, '-broken-img');
                img.setAttribute('height', 0);
            }
        });

    const clickRoll = new Dropdown('.click-roll', {
        wrapperClass: 'click-roll',
        dropdownClass: 'click-roll__block',
        btnClass: 'click-roll__toggle',
        closeOnOutsideClick: false,
        openTypeSlide: true,
        isWrapContent: true,
        clickRoll: true,
        arrows: false,
        infobar: false,
    });

    const shareBlock = new Dropdown('.share-block', {
        wrapperClass: 'share-block',
        dropdownClass: 'share-block__listitems',
        btnClass: 'share-block__button',
        focusTrap: false,
    });

    const messages = new StratisMessage('.message');

    Object.values(window.dropdownList)
        .forEach((el) => {
            if (el.toggler && helpers.hasClass(el.toggler.parentElement, '-is-open')) {
                el.open();
            }
        });

    const accountRemovePopup = document.querySelector('.account-remove__popup');

    if (accountRemovePopup) {
        const btnNotRemove = accountRemovePopup.querySelector('.account-remove__popup-close');

        if (btnNotRemove) {
            btnNotRemove.addEventListener('click', (e) => {
                e.preventDefault();
                const btnClosePopup = accountRemovePopup.querySelector('.fancybox-close-small');
                if (btnClosePopup) {
                    btnClosePopup.click();
                }
            });
        }
    }

    const clearButton = document.querySelector('.js-clear-input');

    if (clearButton) {
        clearButton.addEventListener('click', () => {
            const parent = helpers.findAncestor(clearButton, 'header-search__form-input');
            const input = parent.querySelector('input');
            input.value = '';
        });
    }

    const vote = document.querySelector('.vote');

    if (vote) {
        const voteToggle = vote.querySelector('.vote__toggle');

        if (voteToggle) {
            const voteAdditional = vote.querySelector('.vote__additional');
            const voteBlock = vote.querySelector('.vote__block');

            voteToggle.addEventListener('click', (evt) => {
                evt.preventDefault();
                voteToggle.classList.toggle('vote__toggle--active');
                voteAdditional.classList.toggle('vote__additional--hidden');
                voteBlock.classList.toggle('vote__block--hidden');
            });
        }
    }

    const agreement = new Agreement();

    const tooltip = new Tooltip();

    const pager = document.querySelector('.pager');

    if (pager) {
        const pagerStart = pager.querySelector('.pager__item.-start');
        const pagerEnd = pager.querySelector('.pager__item.-end');

        if (pagerStart) {
            const pagerStartSpanItem = pagerStart.querySelector('span');

            if (pagerStartSpanItem) {
                const nextPager = pager.querySelector('.pager__item:nth-child(4)');
                nextPager.classList.add('-active');
            }
        }

        if (pagerEnd) {
            const pagerEndSpanItem = pagerEnd.querySelector('span');

            if (pagerEndSpanItem) {
                const nextPager = pager.querySelector('.pager__item:nth-child(7)');
                nextPager.classList.add('-active');
            }
        }
    }

    const mainLogos = document.querySelectorAll('.header-bar__logo .logo');

    [...mainLogos].forEach((mainLogo) => {
        mainLogo.removeAttribute('target');
    });

    const btnsRemoveFovorites = [...document.querySelectorAll('.js-stratis-reaction')];
    btnsRemoveFovorites.forEach((btn) => {
        btn.addEventListener('click', () => {
            const container = btn.parentElement.parentElement;
            if (helpers.hasClass(btn, 'js-page-remove ')) {
                container.removeChild(btn.parentElement);
            }
            if (!container.firstElementChild) {
                container.parentElement.parentElement.removeChild(container.parentElement);
            }
        });
    });

    const jsStratisReation = [...document.querySelectorAll('.js-stratis-reaction')];
    jsStratisReation.forEach((btn) => {
        btn.addEventListener('click', ({ target }) => {
            if (helpers.hasClass(target, '-is-active')) {
                const addAttr = target.getAttribute('data-title-add');
                target.innerHTML = addAttr;
                target.setAttribute('title', addAttr);
            } else {
                const removeAttr = target.getAttribute('data-title-remove');
                target.innerHTML = removeAttr;
                target.setAttribute('title', removeAttr);
            }
        });
    });
});
